<div class="vendor-ac-row">
	<div class="vendor-ac-toggle" *ngIf="showIncludeInactiveToggle">
		<mat-slide-toggle [formControl]="includeInactive">Include inactive</mat-slide-toggle>
	</div>
	<mat-form-field class="vendor-ac-field full-width" appearance="outline">
		<mat-label>Vendor</mat-label>
		<input type="text" #vendor matInput [formControl]="vendorSearch" [matAutocomplete]="vendors" appSelectOnFocus>
		<mat-autocomplete #vendors="matAutocomplete" (optionSelected)="selectVendor($event)" [displayWith]="displayFn">
			<mat-option *ngFor="let vendor of filteredItems" [value]="vendor" >
				<b>{{vendor.supplierid}}</b> - {{ vendor.suppname }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</div>
